(() => {
 document.addEventListener('click',event=>{
  const button=event.target.closest('[data-gift-photo]');if(!button)return;
  const gallery=button.closest('.towel-gallery');const photo=gallery.querySelector('#GiftPhoto');
  photo.src=button.dataset.giftPhoto;photo.removeAttribute('srcset');photo.alt=button.querySelector('img').alt;
  gallery.querySelectorAll('[data-gift-photo]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
 });
 const form=document.querySelector('[data-gift-form]');
 if(!form)return;
 const message=form.querySelector('#BoxMessage');
 const custom=form.querySelector('#CustomMessage');
 const review=document.querySelector('[data-gift-review]');
 const sync=()=>{
  const other=message.value==='Other';
  custom.parentElement.hidden=!other;custom.disabled=!other;custom.required=other;
  if(!other){custom.value='';custom.setCustomValidity('');}
 };
 sync();message.addEventListener('change',sync);
 const design=form.querySelector('#TagDesign'),logo=form.querySelector('#TagLogo');
 const syncLogo=()=>{const active=design.value==='Design 12';logo.parentElement.hidden=!active;logo.disabled=!active;logo.required=active;if(!active)logo.value='';};
 syncLogo();design.addEventListener('change',syncLogo);
 const validate=()=>form.querySelectorAll('[data-gift-text]').forEach(input=>{
  input.setCustomValidity(!input.disabled&&input.required&&!input.value.trim()?'Please fill in this field.':'');
 });
 for(const event of ['input','change'])form.addEventListener(event,()=>{validate();if(review)review.hidden=true;});
 form.addEventListener('submit',event=>{
  validate();if(!form.checkValidity()){event.preventDefault();form.reportValidity();return;}
  if(!form.hasAttribute('data-preview-gift'))return;
  event.preventDefault();review.replaceChildren();
  const add=(tag,text)=>{const el=document.createElement(tag);el.textContent=text;review.append(el);};
  add('h2','Your personalized gift box');
  const data=new FormData(form);
  for(const [key,value] of data){if(key==='quantity'||key==='properties[Personalization confirmed]')continue;add('p',key.replace(/^properties\[/,'').replace(/\]$/,'')+': '+(typeof value==='string'?value.trim():value.name));}
  add('p',`Quantity: ${data.get('quantity')} · Item subtotal: $${(76.99*Number(data.get('quantity'))).toFixed(2)} USD`);
  add('p','Preview only — nothing has been ordered or saved. Shipping and taxes are not included.');
  review.hidden=false;review.focus();
 });
})();

document.addEventListener('DOMContentLoaded', () => {
  const design = document.getElementById('GolfAccessoryDesign');
  const section = document.getElementById('GolfAccessoryLogoSection');
  const upload = document.getElementById('GolfAccessoryLogo');

  if (!design || !section || !upload) return;

  function updateLogoUpload() {
    const needsLogo = design.value === 'Design 12';

    section.hidden = !needsLogo;
    upload.disabled = !needsLogo;
    upload.required = needsLogo;

    if (!needsLogo) {
      upload.value = '';
    }
  }

  design.addEventListener('change', updateLogoUpload);
  updateLogoUpload();
});
